import { Head } from '@inertiajs/react';
import { Schedule } from '@/components/schedule';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminTimeSlotsIndex } from '@/types';
import { CreateTimeSlotDialog } from './components/CreateTimeSlotDialog';
import { TimeSlotsTable } from './components/TimeSlotsTable';

export default function Index({
  timeSlots,
  eventSlug,
  eventName,
  startsAt,
  endsAt,
  timezoneOffset,
  timeZone,
  title,
}: AdminTimeSlotsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Time Slots</h1>
            <p className="text-muted-foreground">
              Manage event schedule and time slots for {eventName}
            </p>
          </div>
          <CreateTimeSlotDialog eventSlug={eventSlug} />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Time Slots ({timeSlots.length})</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <TimeSlotsTable eventSlug={eventSlug} timeSlots={timeSlots} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Schedule Preview</CardTitle>
          </CardHeader>
          <CardContent>
            {startsAt && endsAt && (
              <Schedule
                timeSlots={timeSlots}
                startsAt={startsAt}
                endsAt={endsAt}
                timezoneOffset={timezoneOffset}
                timeZone={timeZone}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </>
  );
}
